<form [formGroup]="transactionForm" (ngSubmit)="saveTransaction(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-transfer me-1 font-20 text-primary"></i>{{transactionForm.value.id?'Update':'Add'}} Transaction
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-4">
        <label for="date" class="form-label">Date <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="date" class="form-control ps-1" id="date" formControlName="date"
            [ngClass]="{'is-invalid': submitted && t.date.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && t.date.errors">
            <span *ngIf="t.date.errors.required">Please select a date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <label for="particular" class="form-label">Particular<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-edit-alt'></i></span>
          <input type="text" class="form-control ps-1" id="particular" formControlName="particular"
            placeholder="Enter particular" [ngClass]="{'is-invalid': submitted && t.particular.errors}" autocomplete="off"/>
          <div class="invalid-feedback" *ngIf="submitted && t.particular.errors" >
            <span *ngIf="t.particular.errors.required">Please provide valid particular.</span>
            <span *ngIf="t.particular.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="refId" class="form-label">Reference ID</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bxs-purchase-tag'></i></span>
          <input type="text" class="form-control ps-1" id="refId" placeholder="Reference Id" readonly
            [ngClass]="{'is-invalid': submitted && t.refId.errors}" formControlName="refId" />
        </div>
      </div>
      <div class="col-md-4">
        <label for="invoiceNo" class="form-label">Invoice Number</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-receipt'></i></span>
          <input type="text" class="form-control ps-1" id="invoiceNo" placeholder="Enter Invoice Number"
            [ngClass]="{'is-invalid': submitted && t.invoiceNo?.errors}" formControlName="invoiceNo" />
          <div class="invalid-feedback" *ngIf="submitted && t.invoiceNo?.errors">
            <span *ngIf="t.invoiceNo.errors?.pattern">Please provide valid invoice number.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
          <label class="form-check-label" for="disabled">Disabled</label>
        </div>
      </div>
      <div class="col-md-auto ms-auto mt-5">
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
          <ng-container *ngIf="inProgress?.value=='true'">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{transactionForm.value.id?'Updating...':'Saving...'}}
          </ng-container>
          <ng-container *ngIf="inProgress?.value!='true'">
            <i class="bx bx-save"></i>{{transactionForm.value.id?'Save Changes':'Save'}}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
<section class="rcx-table" style="border-top: 2px dotted var(--bs-primary);" *ngIf="transactionForm.value.id">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class='bx bx-book-content me-1 text-primary'></i>Transaction Entries
                </h5>
              </div>
              <div class="col-sm-12 col-md-auto ms-auto me-2 text-center border-dotted">
                <button type="button" id="save-btn" class="border-dotted-btn">
                  <span class="text-primary mb-2" (click)="upsertTransactionEntry()">
                    <i class="bx bx-plus"></i>Apply Transaction</span>
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="300">Account</th>
                  <th scope="col" width="300">Particular</th>
                  <th scope="col" width="300">Entry Type</th>
                  <th scope="col" width="300">Debit</th>
                  <th scope="col" width="300">Credit</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let transactionEntries of transactionEntries; let i=index">
                  <td>{{transactionEntries.accountName}}</td>
                  <td>{{transactionEntries.particular}}</td>
                  <td>
                    <span class="badge rounded-pill"
                      [ngClass]="transactionEntries.byAccount ? 'bg-warning text-dark' : 'bg-success text-white'">
                      {{ transactionEntries.byAccount ? 'By Account' : 'To Account' }}
                    </span>
                  </td>
                  <td>{{ transactionEntries.byAccount ? '-' : transactionEntries.amount }}</td>
                  <td>{{ transactionEntries.byAccount ? transactionEntries.amount : '-' }}</td>
                  <td class="actions">
                    <i class="bx bx-edit alert-primary" (click)="upsertTransactionEntry(transactionEntries)"></i>
                    <i class="bx bx-trash alert-secondary" (click)="deleteTransactionEntry(transactionEntries,i)"></i>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="8">No transaction entries were found.</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="transactionEntries && transactionEntries.length < 1; else noSearchResults">
                      <td colspan="8">No transaction entries were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="8"
                        *ngIf="searchKeyword && (transactionEntries | search : 'name' : searchKeyword).length == 0">
                        No transaction entries were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
              <tfoot>
                <tr class="bg-light">
                  <th colspan="3" class="text-end">Totals:</th>
                  <th>{{ getTotalCredit() }}</th>
                  <th>{{ getTotalDebit()}}</th>
                  <th class="text-center">
                    <span class="badge rounded-pill" 
                          [ngClass]="getBalance() === 0 ? 'bg-success' : 'bg-danger'">
                      {{ getBalance() === 0 ? 'Balanced' : 'Unbalanced' }}
                    </span>
                  </th>
                </tr>
                <tr *ngIf="getBalance() !== 0" class="bg-light">
                  <th colspan="3" class="text-end">Balance:</th>
                  <th colspan="3" [ngClass]="getBalance() > 0 ? 'text-danger' : 'text-success'">
                    {{ getBalance() }} {{ getBalance() > 0 ? '(Debit > Credit)' : '(Credit > Debit)' }}
                  </th>
                </tr>
              </tfoot>
            </table>
            <div class="text-end mt-3">
              <button class="btn btn-danger d-flex align-items-center justify-content-center float-end"
                (click)="deleteAllTransactionEntries()">
                <i class="bx bx-trash me-2"></i> Clear All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>